module.exports = __webpack_public_path__ + "img/826-ea0b2b.png";